export const MAX_NOTES_LENGTH = 255;
